import { render, staticRenderFns } from "./Saec.vue?vue&type=template&id=55cd580e&scoped=true&"
import script from "./Saec.vue?vue&type=script&lang=js&"
export * from "./Saec.vue?vue&type=script&lang=js&"
import style0 from "./Saec.vue?vue&type=style&index=0&id=55cd580e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cd580e",
  null
  
)

export default component.exports